import React, { useState } from "react";
import {
    FeedReactionChoice, FeedReactionQuickList, FeedMoreReactionButton
} from "src/components/NoticeboardFeedUi";
import { NOTICEBOARD_ALL_REACTIONS, NOTICEBOARD_QUICK_REACTIONS } from "../constants";
import { removeNoticeReaction, setNoticeReaction } from "../api/feedApi";
import NoticeboardReactionsModal from "../components/feed/NoticeboardReactionsModal";
import { ViewerMessage } from "src/components/CheckedIn/CheckedInContentStyles";
import { Notice } from "./noticeTypes";
import { NoticeReactionsBar } from "./NoticeViewerStyles";

interface NoticeReactionsProps {
    notice: Notice;
    token: string;
    interactionUuid: string;
    onUpdated: (notice: Notice) => void;
}

export function NoticeReactions({ notice, token, interactionUuid, onUpdated }: NoticeReactionsProps): React.ReactElement {
    const [picker, setPicker] = useState<boolean>(false);
    const [all, setAll] = useState<boolean>(false);
    const [viewers, setViewers] = useState<boolean>(false);
    const [busy, setBusy] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const react = async (unicode: string): Promise<void> => {
        if (busy) {
            return;
        }
        setBusy(true);
        setError(false);
        try {
            const updated: Notice = notice.reactions.currentUserReaction === unicode
                ? await removeNoticeReaction(token, interactionUuid) : await setNoticeReaction(token, interactionUuid, unicode);
            onUpdated(updated);
            setPicker(false);
            setAll(false);
        } catch {
            setError(true);
        } finally {
            setBusy(false);
        }
    };
    return <>
        <NoticeReactionsBar>
            <button type="button" aria-label="Choose a reaction" aria-expanded={picker}
                onClick={() => { setPicker(value => !value); setAll(false); }}>
                {notice.reactions.currentUserReaction || "⊕"}
            </button>
            <button type="button" onClick={() => setViewers(true)}>
                {notice.reactions.total > 0
                    ? `${notice.reactions.emojis.slice(0, 3).map(emoji => emoji.unicode).join(" ")} ${notice.reactions.total} ${notice.reactions.total === 1 ? "reaction" : "reactions"}`
                    : "Be the first to react…"}
            </button>
        </NoticeReactionsBar>
        {picker && <FeedReactionQuickList style={{ padding: "16px 20px" }} aria-label="Reactions">
            {(all ? NOTICEBOARD_ALL_REACTIONS : NOTICEBOARD_QUICK_REACTIONS).map(unicode => <FeedReactionChoice
                key={unicode} type="button"
                aria-label={`React with ${unicode}`} aria-pressed={notice.reactions.currentUserReaction === unicode}
                disabled={busy} onClick={() => void react(unicode)}>{unicode}</FeedReactionChoice>)}
            <FeedMoreReactionButton type="button" aria-expanded={all} onClick={() => setAll(value => !value)}>
                {all ? "Fewer" : "More"}</FeedMoreReactionButton>
        </FeedReactionQuickList>}
        {error && <ViewerMessage $error role="alert">Your reaction could not be saved. Please try again.</ViewerMessage>}
        <NoticeboardReactionsModal open={viewers} onClose={() => setViewers(false)} token={token}
            interactionUuid={interactionUuid} />
    </>;
}
